import React, { useEffect } from "react";

const rawText = `Zásady ochrany osobních údajů Věrnost

Verze: 1.0
Účinné od: 20.08.2026

1. Kdo je správcem osobních údajů

Správcem osobních údajů v souvislosti s aplikací a službou Věrnost je Ivan Kuznetsov, IČO 19911173, místo podnikání: Nové sady 988/2, 602 00 Staré Brno, e-mail: podpora.vernostapp@gmail.com (dále jen „Správce“ nebo „Věrnost“).

Tyto zásady vysvětlují, jaké osobní údaje můžeme zpracovávat, proč je zpracováváme, komu je můžeme zpřístupnit a jaká práva mají dotčené osoby.

2. Koho se zásady týkají

Zásady se vztahují zejména na: - uživatele mobilní aplikace Věrnost; - návštěvníky webu Věrnost; - vlastníky, kontaktní osoby a pracovníky partnerských podniků používajících Věrnost Business; - osoby, které kontaktují zákaznickou podporu.

3. Jaké údaje můžeme zpracovávat

Podle způsobu používání služby můžeme zpracovávat zejména následující kategorie údajů.

3.1. Účet a identifikační údaje uživatele

Registrace uživatele v Aplikaci probíhá pomocí telefonního čísla a ověřovacího SMS kódu. Uživatel zadává svůj e-mail pro možnost případného obnovení přístupu k účtu. V uživatelském účtu mohou být zpracovávány zejména následující údaje:
- telefonní číslo;
- e-mail;
- interní User ID (identifikátor účtu);
- jméno a příjmení (nepovinné, pouze pokud je uživatel dobrovolně vyplní ve svém profilu);
- stav a nastavení účtu.
Věrnost v současné době neshromažďuje profilovou fotografii ani datum narození uživatele.

3.2. Údaje o používání Věrnost

- věrnostní programy, ke kterým se uživatel připojil;
- návštěvy a digitální razítka;
- získané a využité odměny;
- Premium návštěvy;
- aktivace a využití kupónů;
- hodnocení a recenze;
- historie relevantních akcí nezbytná pro fungování služby, prevenci zneužití a řešení podpory.

3.3. Údaje o předplatném

Můžeme zpracovávat informace o: - typu tarifu; - stavu předplatného; - produktu nebo subscription identifieru; - datu zahájení, obnovení, ukončení nebo expirace předplatného; - identifikátorech poskytovaných systémem pro správu mobilního předplatného.

Platbu za uživatelské Premium zpracovává Apple nebo Google podle platformy. Věrnost běžně nezískává úplné údaje o platební kartě uživatele.

3.4. Věrnost Business

U partnerů a jejich pracovníků můžeme zpracovávat zejména:
- jméno a kontaktní údaje vlastníka nebo kontaktní osoby;
- e-mail používaný pro účet;
- údaje o podniku;
- údaje o zaměstnancích sloužící k vytvoření a správě jejich přístupu, zejména jméno zaměstnance a přístupový PIN kód. Tyto údaje mohou být získány přímo od zaměstnance nebo od vlastníka/oprávněné osoby partnerského podniku za účelem vytvoření a správy jejich účtů;
- historii aktivit zaměstnanců v systému Věrnost Business, například zaznamenání návštěvy, připsání razítka nebo uplatnění kupónu;
- údaje související se správou profilu podniku, věrnostního programu, kupónů a případného předplatného Věrnost Business.

3.5. Technické a bezpečnostní údaje

Můžeme zpracovávat zejména: - IP adresu; - typ zařízení, operační systém a verzi aplikace; - technické identifikátory; - bezpečnostní a serverové logy; - informace o chybách a diagnostice, pokud jsou takové nástroje v dané verzi služby používány.

3.6. Poloha

V současné verzi Věrnost nevyužívá přesnou GPS polohu zařízení pro výběr lokality. Uživatel si město v Aplikaci vybírá zcela ručně. Zpracováván může být údaj o městě, které si uživatel v Aplikaci sám zvolil. Aplikace nevyžaduje ani nevyužívá přístup k přesným polohovým údajům (GPS) vašeho mobilního zařízení.

3.7. Komunikace a podpora

Pokud nás kontaktujete, můžeme zpracovávat obsah zprávy, kontaktní údaje a informace nezbytné pro vyřízení požadavku nebo ticketu.

4. Proč údaje zpracováváme a právní základy

4.1. Plnění smlouvy

Osobní údaje zpracováváme, pokud je to nezbytné pro: - vytvoření a správu účtu; - přihlášení; - evidenci věrnostních programů, návštěv, razítek a odměn; - fungování QR systému; - poskytování Premium funkcí; - kupóny; - poskytování Věrnost Business; - vyřízení požadavků souvisejících se službou.

Právním základem je plnění smlouvy nebo provedení opatření před jejím uzavřením podle čl. 6 odst. 1 písm. b) GDPR.

4.2. Právní povinnost

Některé údaje můžeme zpracovávat, pokud nám jejich uchování nebo jiné zpracování ukládá právní předpis, například v oblasti účetnictví, daní nebo řešení zákonných požadavků orgánů veřejné moci.

Právním základem je čl. 6 odst. 1 písm. c) GDPR.

4.3. Oprávněný zájem

Na základě oprávněného zájmu můžeme zpracovávat přiměřený rozsah údajů zejména pro: - zabezpečení služby a účtů; - prevenci podvodů a zneužití; - ochranu právních nároků; - základní provozní diagnostiku; - ochranu platformy a partnerských podniků před manipulací se systémem.

Právním základem je čl. 6 odst. 1 písm. f) GDPR. Dotčená osoba má právo vznést námitku, pokud jsou splněny podmínky GDPR.

4.4. Souhlas a oprávnění zařízení

Pokud je konkrétní zpracování založeno na souhlasu, například některé formy marketingu nebo nepovinné analytické či marketingové cookies, vyžádáme souhlas samostatně. Souhlas lze kdykoli odvolat; odvoláním není dotčena zákonnost zpracování před jeho odvoláním. Oprávnění zařízení jsou zároveň spravována prostřednictvím nastavení operačního systému zařízení.

4.5. Povinnost poskytnout údaje

Některé osobní údaje (např. telefonní číslo pro ověření) jsou zcela nezbytné pro vytvoření uživatelského účtu nebo pro používání konkrétních funkcí Aplikace. Pokud uživatel tyto nezbytné údaje neposkytne, nemusí být možné účet vytvořit nebo danou funkci používat. Údaje označené jako nepovinné (například jméno a příjmení) uživatel poskytovat nemusí a jejich nevyplnění nemá vliv na funkčnost účtu.

5. Co vidí partnerský podnik

5.1. Služba Věrnost Business neobsahuje žádný samostatný seznam ani celkovou databázi zákazníků, kterou by si mohl partnerský podnik libovolně vyhledávat nebo procházet.

5.2. Osobní údaje uživatele jsou partnerskému podniku zobrazeny výhradně v souvislosti s konkrétní interakcí, zejména při naskenování osobního QR kódu uživatele za účelem správy jeho věrnostního programu.

5.3. Partnerský podnik může v tomto kontextu vidět výhradně:
- telefonní číslo uživatele;
- jméno a příjmení uživatele, pouze pokud je uživatel dobrovolně ve svém profilu vyplnil;
- počet nasbíraných razítek / celkový stav věrnostního programu u daného podniku;
- informaci o tom, zda má uživatel u daného podniku aktuálně dostupnou odměnu;
- kupóny uživatele, které se vztahují k tomuto konkrétnímu podniku, a informace nezbytné pro jejich uplatnění.

5.4. Partnerský podnik prostřednictvím této funkce v žádném případě nesmí a nemůže vidět:
- e-mailovou adresu uživatele;
- aktivitu, návštěvy ani razítka uživatele u jakýchkoli jiných partnerských podniků.

5.5. Rozdělení rolí a odpovědnosti: Partnerský podnik může být ve vztahu k osobním údajům, které používá pro správu vlastního věrnostního programu, samostatným správcem osobních údajů, pokud sám určuje účely a prostředky takového zpracování. Rozdělení rolí mezi Věrnost a partnerský podnik se řídí povahou konkrétního zpracování a příslušnými smluvními podmínkami.

6. Příjemci a poskytovatelé služeb

Pro bezpečný a spolehlivý provoz služby Věrnost využíváme prověřené subdodavatele a poskytovatele technických služeb. V rámci naší architektury se jedná zejména o následující platformy a subjekty:
- backend a API aplikace jsou provozovány prostřednictvím infrastruktury Emergent;
- jako hlavní databázové úložiště je využívána služba MongoDB Atlas;
- pro distribuci mobilní aplikace a správu mobilního předplatného jsou využívány platformy Apple App Store a Google Play;
- pro zasílání ověřovacích SMS kódů může být využívána služba Twilio;
- pro zpracování platebních služeb tam, kde je to relevantní, může být využívána platební brána Stripe.

Osobní údaje můžeme dále zpřístupnit třetím osobám pouze v případech, kdy nám to ukládá zákon nebo oprávněný orgán veřejné moci.

7. Předávání mimo Evropský hospodářský prostor

Někteří technologičtí poskytovatelé mohou zpracovávat údaje mimo Evropský hospodářský prostor. V takovém případě budou použity odpovídající právní mechanismy podle GDPR, například rozhodnutí o odpovídající ochraně, EU-US Data Privacy Framework u způsobilých subjektů nebo standardní smluvní doložky, podle konkrétního poskytovatele.

8. Doba uchování

8.1. Údaje uchováváme výhradně po dobu nezbytnou pro naplnění příslušného účelu zpracování, nebo po dobu stanovenou příslušnými právními předpisy.

8.2. Obecné doby uchování jsou stanoveny následovně:
- údaje aktivního uživatelského účtu uchováváme po celou dobu jeho trvání až do jeho smazání;
- provozní historii věrnostních aktivit v rozsahu nezbytném pro fungování věrnostních programů, výpočet razítek a odměn;
- bezpečnostní a technické logy po přiměřenou dobu potřebnou pro zajištění bezpečnosti a prevenci zneužití platformy;
- daňové a účetní doklady po dobu vyžadovanou platnými právními předpisy;
- osobní údaje zpracovávané na základě souhlasu do doby odvolání souhlasu uživatelem nebo do zániku účelu zpracování.

9. Smazání účtu

9.1. Každý uživatel má možnost smazat svůj uživatelský účet přímo v mobilní aplikaci Věrnost v nastavení svého profilu.

9.2. Po smazání účtu budou veškeré osobní údaje uživatele trvale odstraněny nebo plně anonymizovány, ledaže existuje jiný oprávněný zákonný důvod pro jejich další nezbytné uchování (např. splnění zákonné archivační povinnosti, prevence zneužití systému, nebo ochrana právních nároků).

9.3. Upozornění: Smazání uživatelského účtu v Aplikaci nemusí automaticky zrušit vaše aktivní mobilní předplatné Premium spravované přímo prostřednictvím Apple App Store nebo Google Play. Uživatel je povinen spravovat a případně zrušit své předplatné přímo v nastavení příslušného obchodu s aplikacemi na svém zařízení.

10. Zabezpečení

Používáme přiměřená technická a organizační opatření s cílem chránit osobní údaje před neoprávněným přístupem, ztrátou, zneužitím, změnou nebo zveřejněním.

Žádný systém však nelze považovat za absolutně bezpečný. V případě incidentu postupujeme podle použitelných právních předpisů.

11. Práva subjektu údajů

Za podmínek stanovených GDPR máte zejména právo:
- získat potvrzení, zda vaše osobní údaje zpracováváme, a právo na přístup k těmto údajům;
- požadovat opravu nepřesných nebo neúplných osobních údajů;
- požadovat výmaz osobních údajů (právo být zapomenut), pokud pominul účel nebo souhlas;
- požadovat omezení zpracování osobních údajů;
- získat osobní údaje ve strukturovaném, běžně používaném a strojově čitelném formátu a právo na jejich přenositelnost;
- vznést námitku proti zpracování založenému na oprávněném zájmu;
- odvolat udělený souhlas se zpracováním osobních údajů v případech, kdy je zpracování na souhlasu založeno;
- podat stížnost u dozorového úřadu.

V České republice je dozorovým orgánem Úřad pro ochranu osobních údajů (ÚOOÚ), Pplk. Sochora 27, 170 00 Praha 7.

12. Automatizované rozhodování a profilování

12.1. V současné době Věrnost neprovádí automatizované individuální rozhodování, které by mělo pro uživatele právní účinky nebo se jej obdobným způsobem významně dotýkalo ve smyslu čl. 22 GDPR.

12.2. Pokud bude v budoucnu takové automatizované rozhodování nebo relevantní profilování zavedeno, budou tyto zásady před jeho použitím odpovídajícím způsobem aktualizovány.

13. Marketingová a servisní komunikace

13.1. Servisní zprávy a komunikace: Pro fungování služby vám budeme zasílat nezbytnou servisní komunikaci. Ta zahrnuje zejména SMS ověřovací kódy při přihlašování, zprávy pro obnovení přístupu, bezpečnostní upozornění nebo důležité informace týkající se správy vašeho účtu a poskytované služby. Tato servisní komunikace je nezbytná a nelze se z ní odhlásit.

13.2. Marketingová komunikace: V budoucnu vám můžeme zasílat marketingovou komunikaci, jako jsou informace o zajímavých nabídkách, novinkách v Aplikaci, kupónech nebo relevantních akcích partnerských podniků. Tato sdělení jsou vždy důsledně oddělena od servisních zpráv. Marketingová sdělení budeme zasílat výhradně na základě odpovídajícího právního základu (např. souhlasu nebo oprávněného zájmu). Uživatel má vždy možnost zasílání marketingové komunikace odmítnout nebo se z ní kdykoli jednoduše odhlásit.

14. Cookies, analytika a tracking

14.1. V současné době Věrnost nepoužívá Google Analytics, Firebase Analytics, Meta Pixel ani žádné jiné marketingové či behaviorální sledovací (tracking) nástroje.

14.2. Na našem webu mohou být používány pouze nezbytné technické cookies bez nutnosti souhlasu, které jsou nezbytné pro správné fungování webových stránek.

14.3. Pokud by v budoucnu mělo dojít k nasazení nepovinných analytických, reklamních nebo tracking nástrojů, budou tyto zásady i nastavení souhlasu s cookies (cookie consent) na webu předem odpovídajícím způsobem aktualizovány.

15. Změny těchto zásad

Tyto zásady můžeme aktualizovat zejména v souvislosti se změnami služby, právních předpisů nebo používaných poskytovatelů.

Aktuální verze bude zveřejněna na webu Věrnost s uvedením data účinnosti. O významných změnách můžeme uživatele informovat také prostřednictvím Aplikace.

16. Kontakt

Dotazy a žádosti týkající se ochrany osobních údajů můžete zasílat na: podpora.vernostapp@gmail.com`;

export default function OchranaOsobnichUdaju({ renderHeader, renderFooter }) {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "Zásady ochrany osobních údajů Věrnost";
  }, []);

  const lines = rawText.split("\n").map(line => line.trim()).filter(line => line.length > 0);

  return (
    <div className="min-h-screen bg-[#FDFDFD] text-[#111111] font-sans antialiased selection:bg-[#FF5A00]/10 selection:text-[#FF5A00]">
      {renderHeader()}

      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24 text-left">
        {/* Document Title Header */}
        <div className="border-b-2 border-[#FF5A00]/20 pb-8 mb-10">
          <h1 className="font-heading font-black text-3xl sm:text-4xl lg:text-5xl text-neutral-900 leading-tight mb-4">
            Zásady ochrany osobních údajů Věrnost
          </h1>
          <div className="flex flex-wrap gap-4 sm:gap-6 text-sm font-bold text-neutral-500">
            <span className="bg-neutral-100 px-3.5 py-1.5 rounded-lg border border-neutral-200">Verze: 1.0</span>
            <span className="bg-neutral-100 px-3.5 py-1.5 rounded-lg border border-neutral-200">Účinné od: 20.08.2026</span>
          </div>
        </div>

        {/* Legal Text Content */}
        <div className="space-y-6">
          {lines.slice(3).map((line, idx) => {
            // Check for main section titles (e.g. "1. Kdo je správcem..." or "3.1. Účet a...")
            const isMainHeading = /^\d+\.\s+[A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]/.test(line);
            const isSubHeading = /^\d+\.\d+\.\s+[A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]/.test(line);
            
            if (isMainHeading) {
              return (
                <h2 
                  key={idx} 
                  className="font-heading font-extrabold text-xl sm:text-2xl text-neutral-900 mt-10 mb-4 pt-4 border-b border-neutral-100 pb-2"
                >
                  {line}
                </h2>
              );
            }

            if (isSubHeading) {
              return (
                <h3 
                  key={idx} 
                  className="font-heading font-bold text-lg sm:text-xl text-neutral-900 mt-6 mb-3"
                >
                  {line}
                </h3>
              );
            }

            // Bullet lists
            if (line.includes(" - ")) {
              const parts = line.split(" - ");
              return (
                <div key={idx} className="mb-4">
                  <p className="text-base sm:text-lg text-neutral-700 leading-relaxed mb-2">{parts[0]}</p>
                  <div className="space-y-1">
                    {parts.slice(1).map((part, pIdx) => (
                      <div key={pIdx} className="pl-6 flex items-start space-x-2 text-base text-neutral-700 leading-relaxed">
                        <span className="text-[#FF5A00] mt-1 shrink-0">•</span>
                        <span>{part.trim()}</span>
                      </div>
                    ))}
                  </div>
                </div>
              );
            }

            const isBullet = line.startsWith("-");
            if (isBullet) {
              return (
                <div key={idx} className="pl-6 flex items-start space-x-2 text-base text-neutral-700 leading-relaxed">
                  <span className="text-[#FF5A00] mt-1 shrink-0">•</span>
                  <span>{line.substring(1).trim()}</span>
                </div>
              );
            }

            return (
              <p 
                key={idx} 
                className="text-base sm:text-lg text-neutral-700 leading-relaxed mb-4"
              >
                {line}
              </p>
            );
          })}
        </div>
      </main>

      {renderFooter()}
    </div>
  );
}
